import { APIResponse, GETArrayResponse } from '@cbgms/api/helpers'
import { IArrayResponse } from '@cbgms/api/response'

export interface IAddressAutocomplete {
  AutoCompleteText: string
  AutoCompleteID: string
  SingleResult: boolean
}

export interface IAddressSearchResolveResult {
  Street: string
  HouseNumber: string
  City: string
  Country: string
  State: string
  ZipCode: string
  FormattedAddress: string
  AdditionalAddressLines: string
}

export type GETAddressSearchAutoCompleteResponse = GETArrayResponse<IAddressAutocomplete>
export const getAddressSearchAutoCompleteRequest = (Country: string, SearchString: string) => ({
  api: 'gms',
  request: {
    params: {
      Country,
      SearchString
    },
    method: 'GET',
    url: '/miscellaneous/address/search/autocomplete'
  }
})

export type GETAddressSearchByIdAutoCompleteResponse = IArrayResponse<IAddressAutocomplete>
export const getAddressSearchByIdAutoCompleteRequest = (Country: string, Id: string) => ({
  api: 'gms',
  request: {
    params: {
      Country,
      Id
    },
    method: 'GET',
    url: '/miscellaneous/address/search/autocomplete/id'
  }
})

export type GETAddressSearchResolveResponse = APIResponse<IAddressSearchResolveResult>
export const getAddressSearchResolveRequest = (Country: string, SearchString: string) => ({
  api: 'gms',
  request: {
    params: {
      Country,
      SearchString
    },
    method: 'GET',
    url: '/miscellaneous/address/search/resolve'
  }
})
